import {
    GET_TODAY_BALANCE_FAILED, GET_TODAY_BALANCE_LOADING, GET_TODAY_BALANCE_SUCCESS, REMOVE_TODAY_BALANCE
} from "../types";

const initialState = {
    data: null,
    loading: null,
    error: null,
};

export const getMerchantTodayBalanceReducer = (
    state = initialState,
    action: { type: any; loading: any; payload: any; error: any }
) => {
    switch (action.type) {
        case GET_TODAY_BALANCE_LOADING:
            return {
                ...state,
                loading: action.loading,
                error: null,
            };
        case GET_TODAY_BALANCE_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                data: action.payload,
            };
        case GET_TODAY_BALANCE_FAILED:
            return {
                ...state,
                loading: false,
                error: action.error,
            };
        case REMOVE_TODAY_BALANCE:
            return initialState;

        default:
            return state;
    }
};
